import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ViewJustification } from "./view-justification"
import { EditJustification } from "./edit-justification"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"

export function Justification() {
    const { tailoringAudit, justification, taskTailored } = useBoundContext()

    return (
        <If value={taskTailored}>
            <If value={justification}>
                <EditJustification />
                <Else>
                    <If value={!!tailoringAudit?.payload?.reason}>
                        <ViewJustification />
                    </If>
                </Else>
            </If>
        </If>
    )
}
